import React, { useState } from 'react'
import { Button, Menu, MenuItem } from '@mui/material'
import { FileDownloadRounded } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'

const DropdownButton = ({
  onClick,
  disabled,
}: {
  onClick: (option: string) => void
  disabled: boolean
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const { t } = useTranslation()

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleOptionClick = (option: string) => {
    onClick(option)
    handleClose()
  }

  return (
    <>
      <Button
        variant="contained"
        onClick={handleClick}
        aria-controls={open ? 'dropdown-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        sx={{ mb: 4 }}
        disabled={disabled}
        startIcon={<FileDownloadRounded />}
      >
        {t('Export KPIs')}
      </Button>

      <Menu
        id="dropdown-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem onClick={() => handleOptionClick('pdf')}>{t('as PDF')}</MenuItem>
        <MenuItem onClick={() => handleOptionClick('csv')}>{t('as CSV')}</MenuItem>
      </Menu>
    </>
  )
}

export default DropdownButton
